var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return !_vm.maintainRatio
    ? _c("img", {
        ref: "image",
        class: { auto: _vm.fluid },
        style: _vm.imgStyleObject,
        attrs: {
          src: _vm.imgSrc,
          datasrc: _vm.singleSrcUrl,
          sizes: _vm.sizesArray,
          alt: _vm.altText,
          height: _vm.height,
          width: _vm.width
        }
      })
    : _c(
        "div",
        { staticClass: "ns-image__background", style: _vm.divStyleObject },
        [
          _c(
            "div",
            {
              staticClass: "ns-image__background-image",
              class: [
                { "ns-image__contain": _vm.imageFit === "contain" },
                _vm.ratioClass
              ],
              style: _vm.divBgStyleObject,
              attrs: { title: _vm.altText }
            },
            [_vm._t("default")],
            2
          )
        ]
      )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }